import {useMemo,useState} from 'react';
import {useIntl} from '@/react-intl';
import {Button} from '@/design-system/ds-0/components/Button';
import StudioCheckbox from '../shared/StudioCheckbox';
import type {DesignModuleSpecJson} from '../data/contracts';
import {applySettings,proposeSettings,type SettingsProposal} from './settingsDetection';

/** CMDB-LAYOUT C (GAP-MODEL-SETTINGS) : réglages du prototype proposés comme champs natifs de l'entité de réglages (décochés). */
const T='moduleStudio.template.settings.';
/** Signe de mise en page (aucun texte de l'utilisateur). */
const SEPARATOR=' · ';
export default function SettingsDetectedReview({spec,apply}:{spec:DesignModuleSpecJson;apply:(next:DesignModuleSpecJson,page:string)=>void}){
 const intl=useIntl(),t=(key:string,values?:Record<string,string|number>)=>intl.formatMessage({id:T+key},values);
 const proposals=useMemo(()=>proposeSettings(spec),[spec]);
 const [checked,setChecked]=useState<Record<string,boolean>>({});
 if(!proposals.length)return null;
 const id=(proposal:SettingsProposal)=>proposal.page+'#'+proposal.block;
 const label=(key:string)=>{const page=(spec.pages as {key:string;label?:Record<string,string>}[]).find(item=>item.key===key);return page?.label?.[String(intl.locale)]??page?.label?.fr??key;};
 return <fieldset><legend>{t('title')}</legend>
  <p>{t('help')}</p>
  {proposals.map(proposal=><div key={id(proposal)}>
   <p><strong>{label(proposal.page)}</strong>{SEPARATOR}{t('entity',{entity:proposal.entity})}</p>
   <ul>{proposal.changes.map((change,index)=><li key={index}>{change.kind==='input'?t('input',{field:change.field??''}):t('palette',{count:change.fields?.length??0})}</li>)}<li>{t('realized',{count:proposal.realized})}</li></ul>
   <StudioCheckbox checked={!!checked[id(proposal)]} onChange={event=>setChecked(previous=>({...previous,[id(proposal)]:event.target.checked}))}>{t('accept')}</StudioCheckbox>
  </div>)}
  <Button disabled={!proposals.some(proposal=>checked[id(proposal)])} onClick={()=>{
   let next=spec;const pages:string[]=[];
   for(const proposal of proposals)if(checked[id(proposal)]){next=applySettings(next,proposal);pages.push(proposal.page);}
   apply(next,pages[0]);setChecked({});
  }}>{t('apply')}</Button>
 </fieldset>;
}
